import { sxTable } from './sxProps';
import './styles.css'
import { Table, TableBody, TableContainer, TableHead, TableCell, TableRow, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import { TabelaTitulosProps } from '../../../interfaces/props/Financeiro/DemonstrativoFatura/TabelaTitulosProps';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';

function TabelaTitulos(props: TabelaTitulosProps) {

    const accessibility = useAccessibility();

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        ...{
            fontFamily: 'Unimed-Sans',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            width: '26%'
        },
            ...accessibility.calculateTextStyle(14)
        }));

    const ButtonTableCell = styled(TableCell)(({ theme }) => ({
        ...{
            fontFamily: 'Unimed-Sans',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            width: '22%'
        },
        ...accessibility.calculateTextStyle(14)
    }));
    
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#F9F9F9'
        },
    }));

    return (
        <div>
          <TableContainer className='container-table' style={accessibility.contrastBorderAccessibility} sx={sxTable} component={Paper}>
            <Table stickyHeader size="small" aria-label="a dense table">
                <TableHead>
                <TableRow>
                    <StyledTableCell><b>{props.columnLabel || 'Fatura'}</b></StyledTableCell>
                    <StyledTableCell align="left"><b>Emissão</b></StyledTableCell>
                    <StyledTableCell align="left"><b>Vencimento</b></StyledTableCell>
                    <StyledTableCell align="left"></StyledTableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {props.data.map((row) => (
                    <StyledTableRow
                        key={row.idTitulo}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                        <StyledTableCell component="th" scope="row">
                            {row.idTitulo}
                        </StyledTableCell>
                        <StyledTableCell align="left">{row.dtEmissao}</StyledTableCell>
                        <StyledTableCell align="left">{row.dtVencimento}</StyledTableCell>
                        <ButtonTableCell align="left">
                            <button 
                                className='demonstrativo-button' 
                                onClick={()=> props.onVisualizarClicked(row.idTitulo)}
                                style={{...accessibility.calculateFontStyle(14), ...accessibility.contrastColorAccessibility}}
                                aria-label={`{props.buttonLabel || 'Ver fatura'} vencendo em ${row.dtVencimento}`}
                            >
                                {props.buttonLabel || 'Ver fatura'}
                            </button>
                        </ButtonTableCell>
                    </StyledTableRow>
                ))}
                </TableBody>
            </Table>
            </TableContainer>
        </div>
    )
}

export default TabelaTitulos;

